import React from "react";
import ReactDOM from "react-dom";

// FontAwesome 5 — bundled by webpack, no CDN, no manual file copy.
// Includes all `fa-*` icons used across SocialMedia, the page-up arrow,
// skill icons, etc.
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./index.css";
import App from "./App";

// Belt-and-suspenders for Chrome auto-translate: even though index.html ships
// with <html lang="en" dir="ltr">, a previously cached SPA bundle, a browser
// extension, or a stale service worker can leave the live <html> tagged as
// another language and break translate detection. Re-assert the locale once
// on boot before React paints.
if (typeof document !== "undefined") {
  document.documentElement.lang = "en";
  document.documentElement.dir = "ltr";
}

// Boot with a hard safety net. If React itself throws during the initial
// render, log the real error to the console and leave #root unmarked so the
// boot guard in public/index.html paints the branded static fallback instead
// of a white page.
const rootEl = document.getElementById("root");
try {
  ReactDOM.render(<App />, rootEl, () => {
    // Tell the boot guard we're alive — it stands down.
    rootEl.setAttribute("data-rd-mounted", "1");
    // eslint-disable-next-line no-console
    console.info("[rashiddev] app mounted — build ok");
  });
} catch (err) {
  // eslint-disable-next-line no-console
  console.error("[rashiddev boot] React failed to mount:", err);
  if (window.__rdErrors) window.__rdErrors.push("[react-mount] " + (err && err.message));
  // Don't rethrow — the index.html boot guard will render the fallback UI.
}
